<div v-if="isPending || Array.isArray(cartVouchers)" class="cart-vouchers">
  <div class="cart-vouchers__headline">{{ $t('app.discount_vouchers.headline') }}</div>
  <div
    class="cart-voucher-block cart-voucher-block--clickable"
    :aria-label="$t('my_account.the_club.use_reward')"
    @click="onBlockClick"
    @keydown.enter.prevent="onBlockClick"
    @keydown.space.prevent="onBlockClick"
  >
    <div class="cart-vouchers__trigger">
      <div class="cart-vouchers__counter" aria-hidden="true">
        <svg class="cart-vouchers__ticket-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
          <path d="M0 0H64V25.1819C62.344 26.2793 59.4997 28.8217 59.4997 31.7828C59.4997 34.7439 62.344 37.2862 64 38.3837V64H0V38.3837C1.65659 37.2866 4.50132 34.7438 4.50132 31.7821C4.50132 28.8204 1.65659 26.2776 0 25.1805V0Z" fill="#FDEBE9"/>
        </svg>
        <span class="cart-vouchers__count">{{ availableVouchers === 0 ? '%' : availableVouchers }}</span>
      </div>
      <div class="cart-vouchers__text">
        <div class="cart-vouchers__title">{{ availableVouchers === 0 ? $t('app.voucher.enter_code_title') : (availableVouchers === 1 ? $t('app.voucher.voucher_new_title_singular') : $t('app.voucher.voucher_new_title_plural')) }}</div>
        <p class="cart-vouchers__subtitle">{{ availableVouchers === 0 ? $t('app.voucher.enter_code_text') : $t('app.discount_vouchers.subtitle_1') }}</p>
        <button type="button" class="cart-vouchers__action" @click.stop="openModal">{{ redeemedCount > 0 ? $t('app.discount_vouchers.redeemed_vouchers', {count: redeemedCount}) : $t('my_account.the_club.use_reward') }}</button>
      </div>
    </div>
    <div class="cart-vouchers__icon iconfont-arrow-right"></div>
  </div>
</div>
